<template>
  <div>
    <div v-if="!created">
      <div class="edit-tabs edit-wrapper-admin">
        <div class="left-edit">
          <h1 class="create-header">Original</h1>
          <div class="diffToggle">
            <v-checkbox
              v-model="showDiffOnly"
              label="Nur Unterschiedliche"
              color="#33bbff"
              hide-details
            ></v-checkbox>
          </div>
          <form action="create" method="post">
            <div v-if="!titleEqual || !showDiffOnly">
              <label class="big-label">Titel</label>
              <input class="input-text" placeholder="Titel" v-model="title" />
              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!categoriesEqual || !showDiffOnly">
              <label class="big-label">Kategorie</label>
              <category-tabs
                v-model="chosenCategories"
                :categories="categories"
              ></category-tabs>
              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!durationEqual || !showDiffOnly">
              <div class="creation-row">
                <div class="creation-col-left">
                  <label class="big-label icon-label"
                    ><img src="/img/icons/creation/duration.svg" />Dauer</label
                  >
                </div>
                <div class="creation-col-right">
                  <creation-duration
                    @changeUnit="changeUnit"
                    v-model="duration"
                    :duration_unit="duration_unit"
                  ></creation-duration>
                </div>
              </div>

              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!preperationEqual || !showDiffOnly">
              <div class="creation-row creation-row-long">
                <div class="creation-col-left">
                  <label class="big-label icon-label">Vorbereitungszeit</label>
                </div>
                <div class="creation-col-right">
                  <creation-preperation
                    v-model="preperation"
                  ></creation-preperation>
                </div>
              </div>

              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!ageEqual || !showDiffOnly">
              <div class="creation-row">
                <div class="creation-col-left">
                  <label class="big-label icon-label"
                    >Altersklasse <br />(Jahre)</label
                  >
                </div>
                <div class="creation-col-right">
                  <creation-age v-model="age"></creation-age>
                </div>
              </div>

              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!amountEqual || !showDiffOnly">
              <div class="creation-row">
                <div class="creation-col-left">
                  <label class="big-label icon-label-2"
                    ><img src="/img/icons/creation/age.svg" />Anzahl<br />
                    Personen</label
                  >
                </div>
                <div class="creation-col-right">
                  <creation-amount v-model="amount"></creation-amount>
                </div>
              </div>

              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!priceEqual || !showDiffOnly">
              <div class="creation-row">
                <div class="creation-col-left">
                  <label class="big-label icon-label">Kosten</label>
                </div>
                <div class="creation-col-right">
                  <creation-price v-model="price"></creation-price>
                </div>
              </div>

              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!locationEqual || !showDiffOnly">
              <div class="creation-row">
                <div class="creation-col-left">
                  <label class="big-label icon-label">Aufenthalt</label>
                </div>
                <div class="creation-col-right">
                  <creation-location v-model="location"></creation-location>
                </div>
              </div>
              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!buyEqual || !showDiffOnly">
              <div class="creation-row">
                <div class="creation-col-left">
                  <label class="big-label icon-label">Kaufen/Buchen</label>
                </div>
                <div class="creation-col-right">
                  <input class="input-text" v-model="buy_url" />
                </div>
              </div>
              <div class="void-divider"></div>
            </div>
            <div v-if="!websiteEqual || !showDiffOnly">
              <div class="creation-row">
                <div class="creation-col-left">
                  <label class="big-label icon-label">Website</label>
                </div>
                <div class="creation-col-right">
                  <input class="input-text" v-model="website_url" />
                </div>
              </div>

              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!descriptionEqual || !showDiffOnly">
              <div class="creation-row">
                <div class="creation-col-left">
                  <label class="big-label icon-label">Beschreibung</label>
                </div>
                <div class="creation-col-right">
                  <textarea
                    class="input-text text-area"
                    v-model="description"
                  />
                </div>
              </div>

              <div class="horizontal-divider"></div>
            </div>
            <!-- <div class="creation-row">
          <div class="creation-col-left">
            <label class="big-label icon-label">Bilder</label>
          </div>
           <div class="creation-col-right">
            <textarea class="input-text text-area" v-model="description" />
          </div>
        </div> -->

            <!-- <div class="horizontal-divider"></div> -->
            <div v-if="!infrastructureEqual || !showDiffOnly">
              <label class="big-label big-label-mb">Infrastruktur</label>
              <creation-infrastructure v-model="infrastructure" />

              <div class="horizontal-divider"></div>
            </div>
            <div
              v-if="!geotimeEqual || !showDiffOnly"
              class="geolocation-time-wrapper"
            >
              <div class="g-map">
                <google-maps
                  :neutral="neutral"
                  :lat="geolocation ? geolocation.latlng.lat : null"
                  :lng="geolocation ? geolocation.latlng.lng : null"
                  :disabled="noAddress"
                >
                </google-maps>
              </div>
              <div class="geolocation-time">
                <div class="label-row">
                  <div class="big-label">Adresse</div>
                  <div class="disable-cb">
                    <v-checkbox
                      v-model="noAddress"
                      label="Keine Adresse"
                      color="#33bbff"
                      @change="togglenoAddress()"
                      hide-details
                    ></v-checkbox>
                  </div>
                </div>

                <div class="geolocation-wrapper">
                  <div id="gp-w" class="geolocation-input">
                    <gmap-autocomplete
                      @place_changed="gAdress"/>
                  </div>
                </div>
                <!-- <creation-geolocation
                  :api-key="apiKey"
                  :app-id="appId"
                  :key="`${appId}-${apiKey}`"
                  v-model="geolocation"
                  :prefilled="idea.address"
                /> -->
                <div class="label-row label-row-time">
                  <div class="big-label">Zeit</div>
                  <div class="disable-cb">
                    <v-checkbox
                      v-model="noTime"
                      label="Keine Öffnungszeiten"
                      color="#33bbff"
                      hide-details
                    ></v-checkbox>
                  </div>
                </div>
                <textarea
                  :class="{ 'input-disabled': noTime }"
                  :disabled="noTime"
                  class="input-text text-area"
                  v-model="time"
                />
              </div>
            </div>

            <div
              v-if="!geotimeEqual || !showDiffOnly"
              class="horizontal-divider"
            ></div>

            <!-- <button
          @click.prevent="editIdea()"
          class="order-link btn btn-blue"
          href="#"
        >
          <img src="/img/icons/save.svg" />Speichern
        </button> -->
          </form>
        </div>

        <div class="right-edit">
          <h1 class="create-header">Änderung</h1>
          <form action="create" method="post">
            <div v-if="!titleEqual || !showDiffOnly">
              <label class="big-label">Titel</label>
              <input
                readonly
                class="input-text"
                placeholder="Titel"
                v-model="titleEdit"
              />
              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!categoriesEqual || !showDiffOnly">
              <label class="big-label">Kategorie</label>

              <category-tabs
                v-model="chosenCategoriesEdit"
                :categories="categories"
                readonly
              ></category-tabs>
              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!durationEqual || !showDiffOnly">
              <div class="creation-row">
                <div class="creation-col-left">
                  <label class="big-label icon-label"
                    ><img src="/img/icons/creation/duration.svg" />Dauer</label
                  >
                </div>
                <div class="creation-col-right">
                  <creation-duration
                    readonly
                    v-model="durationEdit"
                    :duration_unit="duration_unit_edit"
                  ></creation-duration>
                </div>
              </div>

              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!preperationEqual || !showDiffOnly">
              <div class="creation-row creation-row-long">
                <div class="creation-col-left">
                  <label class="big-label icon-label">Vorbereitungszeit</label>
                </div>
                <div class="creation-col-right">
                  <creation-preperation
                    readonly
                    v-model="preperationEdit"
                  ></creation-preperation>
                </div>
              </div>

              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!ageEqual || !showDiffOnly">
              <div class="creation-row">
                <div class="creation-col-left">
                  <label class="big-label icon-label"
                    >Altersklasse <br />(Jahre)</label
                  >
                </div>
                <div class="creation-col-right">
                  <creation-age readonly v-model="ageEdit"></creation-age>
                </div>
              </div>

              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!amountEqual || !showDiffOnly">
              <div class="creation-row">
                <div class="creation-col-left">
                  <label class="big-label icon-label-2"
                    ><img src="/img/icons/creation/age.svg" />Anzahl<br />
                    Personen</label
                  >
                </div>
                <div class="creation-col-right">
                  <creation-amount
                    readonly
                    v-model="amountEdit"
                  ></creation-amount>
                </div>
              </div>

              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!priceEqual || !showDiffOnly">
              <div class="creation-row">
                <div class="creation-col-left">
                  <label class="big-label icon-label">Kosten</label>
                </div>
                <div class="creation-col-right">
                  <creation-price readonly v-model="priceEdit"></creation-price>
                </div>
              </div>

              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!locationEqual || !showDiffOnly">
              <div class="creation-row">
                <div class="creation-col-left">
                  <label class="big-label icon-label">Aufenthalt</label>
                </div>
                <div class="creation-col-right">
                  <creation-location
                    readonly
                    v-model="locationEdit"
                  ></creation-location>
                </div>
              </div>

              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!buyEqual || !showDiffOnly">
              <div class="creation-row">
                <div class="creation-col-left">
                  <label class="big-label icon-label">Kaufen/Buchen</label>
                </div>
                <div class="creation-col-right">
                  <input readonly class="input-text" v-model="buy_urlEdit" />
                </div>
              </div>
              <div class="void-divider"></div>
            </div>
            <div v-if="!websiteEqual || !showDiffOnly">
              <div class="creation-row">
                <div class="creation-col-left">
                  <label class="big-label icon-label">Website</label>
                </div>
                <div class="creation-col-right">
                  <input
                    readonly
                    class="input-text"
                    v-model="website_urlEdit"
                  />
                </div>
              </div>

              <div class="horizontal-divider"></div>
            </div>
            <div v-if="!descriptionEqual || !showDiffOnly">
              <div class="creation-row">
                <div class="creation-col-left">
                  <label class="big-label icon-label">Beschreibung</label>
                </div>
                <div class="creation-col-right">
                  <textarea
                    class="input-text text-area"
                    v-model="descriptionEdit"
                    readonly
                  />
                </div>
              </div>

              <div class="horizontal-divider"></div>
            </div>
            <!-- <div class="creation-row">
          <div class="creation-col-left">
            <label class="big-label icon-label">Bilder</label>
          </div>
           <div class="creation-col-right">
            <textarea class="input-text text-area" v-model="description" />
          </div>
        </div> -->

            <!-- <div class="horizontal-divider"></div> -->
            <div v-if="!infrastructureEqual || !showDiffOnly">
              <label class="big-label big-label-mb">Infrastruktur</label>
              <creation-infrastructure readonly v-model="infrastructureEdit" />

              <div class="horizontal-divider"></div>
            </div>
            <div
              v-if="!geotimeEqual || !showDiffOnly"
              class="geolocation-time-wrapper"
            >
              <div class="g-map">
                <google-maps
                  :neutral="neutralEdit"
                  :lat="geolocationEdit ? geolocationEdit.latlng.lat : null"
                  :lng="geolocationEdit ? geolocationEdit.latlng.lng : null"
                  :disabled="noAddressEdit"
                >
                </google-maps>
              </div>
              <div class="geolocation-time">
                <div class="label-row">
                  <div class="big-label">Adresse</div>
                  <div class="disable-cb">
                    <v-checkbox
                      readonly
                      v-model="noAddressEdit"
                      label="Keine Adresse"
                      color="#33bbff"
                      @change="togglenoAddress()"
                      hide-details
                    ></v-checkbox>
                  </div>
                </div>

                <div class="geolocation-wrapper">
                  <div id="gp-w-e" class="geolocation-input">
                    <gmap-autocomplete/>
                  </div>
                </div>
                <!-- <creation-geolocation
                  readonly
                  :api-key="apiKey"
                  :app-id="appId"
                  :key="`${appId}-${apiKey}`"
                  v-model="geolocationEdit"
                  :prefilled="edit.address"
                /> -->
                <div class="label-row label-row-time">
                  <div class="big-label">Zeit</div>
                  <div class="disable-cb">
                    <v-checkbox
                      readonly
                      v-model="noTimeEdit"
                      label="Keine Öffnungszeiten"
                      color="#33bbff"
                      hide-details
                    ></v-checkbox>
                  </div>
                </div>
                <textarea
                  readonly
                  :class="{ 'input-disabled': noTimeEdit }"
                  :disabled="noTimeEdit"
                  class="input-text text-area"
                  v-model="timeEdit"
                />
              </div>
            </div>

            <div
              v-if="!geotimeEqual || !showDiffOnly"
              class="horizontal-divider"
            ></div>
          </form>
        </div>
      </div>
      <button
        @click.prevent="editIdea()"
        class="order-link btn btn-blue"
        href="#"
      >
        <img src="/img/icons/save.svg" />Speichern
      </button>
    </div>
    <div v-if="created" class="creation-success">
      <img src="/img/success.svg" />
      <h1>Die Idee wurde erfolgreich editiert</h1>

      <div class="btn-row">
        <a href="/backend" class="btn btn-white"> Zurück</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["categories", "idea", "edit"],
  data() {
    return {
      titleEqual: false,
      categoriesEqual: false,
      durationEqual: false,
      preperationEqual: false,
      geotimeEqual: false,
      ageEqual: false,
      amountEqual: false,
      priceEqual: false,
      locationEqual: false,
      buyEqual: false,
      websiteEqual: false,
      descriptionEqual: false,
      infrastructureEqual: false,
      showDiffOnly: true,
      appId: "plA1E1SCQOJJ",
      apiKey: "3bc0540d1aa0afafa8f07124134257f3",
      geolocation: null,
      geolocationEdit: null,
      noAddress: true,
      noAddressEdit: true,
      noTime: true,
      noTimeEdit: true,
      neutral: true,
      neutralEdit: true,
      time: "",
      timeEdit: "",
      errorMessages: [],
      title: this.idea.title,
      titleEdit: this.edit.title,
      description: this.idea.description,
      descriptionEdit: this.edit.description,
      buy_url: this.idea.buy_url,
      buy_urlEdit: this.edit.buy_url,
      website_url: this.idea.website_url,
      website_urlEdit: this.edit.website_url,
      age: [this.idea.age_from, this.idea.age_to],
      ageEdit: [this.edit.age_from, this.edit.age_to],
      noAddress: true,
      noAddressEdit: true,
      noTime: true,
      noTimeRedit: true,
      preperation: "0",
      preperationEdit: "0",
      chosenCategories: {},
      chosenCategoriesEdit: {},
      duration: null,
      durationEdit: null,
      duration_unit: this.idea.duration_unit ? "1" : "0",
      duration_unit_edit: this.edit.duration_unit ? "1" : "0",
      amount: null,
      amountEdit: null,
      price: null,
      priceEdit: null,
      location: {
        indoor: this.idea.indoor,
        outdoor: this.idea.outdoor,
      },
      locationEdit: {
        indoor: this.edit.indoor,
        outdoor: this.edit.outdoor,
      },
      infrastructure: {
        wheelchair: this.idea.wheelchair,
        stroller: this.idea.stroller,
        transportation: this.idea.transportation,
        parking: this.idea.parking,
        dogs: this.idea.dogs,
        drinking: this.idea.drinking,
        firepit: this.idea.firepit,
        picnic: this.idea.picnic,
        playground: this.idea.playground,
        restaurant: this.idea.restaurant,
        toilet: this.idea.toilet,
      },
      infrastructureEdit: {
        wheelchair: this.edit.wheelchair,
        stroller: this.edit.stroller,
        transportation: this.edit.transportation,
        parking: this.edit.parking,
        dogs: this.edit.dogs,
        drinking: this.edit.drinking,
        firepit: this.edit.firepit,
        picnic: this.edit.picnic,
        playground: this.edit.playground,
        restaurant: this.edit.restaurant,
        toilet: this.edit.toilet,
      },
      created: false,
    };
  },
  methods: {
    gAdress(e) {
      let postal_code = null;
      let street = null;
      let number = "";
      let city = null;
      for (var i = 0; i < e.address_components.length; i++) {
        for (var j = 0; j < e.address_components[i].types.length; j++) {
          if (e.address_components[i].types[j] == "postal_code") {
            postal_code = e.address_components[i].long_name;
          }

          if (e.address_components[i].types[j] == "route") {
            street = e.address_components[i].long_name;
          }

          if (e.address_components[i].types[j] == "street_number") {
            number = e.address_components[i].long_name ?? "";
          }

          if (e.address_components[i].types[j] == "locality") {
            city = e.address_components[i].long_name;
          }
        }
      }
      console.log("postal_code", postal_code);
      let tmpGeo = {
        latlng: {
          lat: e.geometry.location.lat(),
          lng: e.geometry.location.lng(),
        },
        name: e.name,
        street: street + " " + number,
        zip: postal_code,
        city: city,
      };

      this.geolocation = tmpGeo;
    },
    changeUnit(val) {
      // console.log("1 is hour", val);
      if (val === "1") {
        if (Array.isArray(this.duration)) {
          this.duration = [1, 4];
        } else {
          this.duration = 3;
        }
      } else {
        if (Array.isArray(this.duration)) {
          this.duration = [
            Math.floor(this.duration[0]),
            Math.floor(this.duration[1]),
          ];
        } else {
          this.duration = Math.floor(this.duration);
        }
      }

      this.duration_unit = val;
    },
    togglenoAddress() {
      this.neutral = this.noAddress;
      if (this.noAddress) {
        document.querySelector(".ap-input").classList.add("input-disabled");
        document.querySelector(".ap-input").disabled = true;
      } else {
        document.querySelector(".ap-input").classList.remove("input-disabled");
        document.querySelector(".ap-input").disabled = false;
      }
    },
    async editIdea() {
      //some tweaks because ranges gives us an array while fixed value is just an array -> backend always awaits array
      let durationTmp = this.sanitizeDuration();
      let amountTmp = this.sanitizeAmount();
      let priceTmp = this.sanitziePrice();
      let timeTmp = this.sanitizeTime();
      let geolocationTmp = this.sanitizeGeolocation();

      let payload = {
        categories: {
          main: this.chosenCategories.main
            ? this.chosenCategories.main.id
            : null,
          sub: this.chosenCategories.sub ? this.chosenCategories.sub.id : null,
          subsub: this.chosenCategories.subsub
            ? this.chosenCategories.subsub.id
            : null,
        },
        age: this.age,
        preperation: this.preperation,
        duration: durationTmp,
        amount: amountTmp,
        price: priceTmp,
        location: this.location,
        title: this.title,
        buy_url: this.buy_url,
        website_url: this.website_url,
        description: this.description,
        infrastructure: this.infrastructure,
        time: timeTmp,
        geolocation: geolocationTmp,
        idea_id: this.idea.id,
        duration_unit: this.duration_unit === "1" ? 1 : 0,
      };
      axios
        .post("/editAdmin/" + this.idea.id, payload)
        .then((res) => {
          if (res.status == 201) {
            this.created = true;
            document
              .querySelector("main")
              .scrollIntoView({ behavior: "smooth" });
          }
          console.log(res.data);
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
    sanitizeDuration() {
      if (typeof this.duration === "number") {
        if (this.duration_unit === "1") {
          return [this.duration * 60];
        }
        return [this.duration];
      }
      if (this.duration_unit === "1") {
        let tmp = [];
        tmp[0] = this.duration[0] * 60;
        tmp[1] = this.duration[1] * 60;
        return tmp;
      }
      return this.duration;
    },
    sanitizeAmount() {
      if (typeof this.amount === "number") {
        return [this.amount];
      }
      return this.amount;
    },
    sanitziePrice() {
      if (typeof this.price === "number") {
        return [this.price];
      }
      return this.price;
    },
    sanitizeTime() {
      if (this.noTime) {
        return "";
      }
      return this.time;
    },
    sanitizeGeolocation() {
      if (this.noAddress) {
        return null;
      }
      // this.geolocation.name = this.idea.address;
      // this.geolocation.street = this.idea.stree;
      // this.geolocation.zip = this.idea.zip;
      // this.geolocation.city = this.idea.city;
      return this.geolocation;
    },
  },
  created() {
    console.log("This is the Data i have", this.idea);

    //PREPARE TIME DATA

    if (this.idea.time === null) {
      this.noTime = true;
    } else {
      this.noTime = false;
      this.time = this.idea.time;
    }

    if (this.edit.time === null) {
      this.noTimeEdit = true;
    } else {
      this.noTimeEdit = false;
      this.timeEdit = this.edit.time;
    }

    //PREPARE DURATION DATA
    if (this.idea.duration_unit) {
      console.log("t");
      this.duration_unit = "1";
      if (this.idea.duration_from !== null && this.idea.duration_to !== null) {
        this.duration = [
          this.idea.duration_from / 60,
          this.idea.duration_to / 60,
        ];
      } else if (
        this.idea.duration_from !== null &&
        this.idea.duration_to === null
      ) {
        this.duration = this.idea.duration_from / 60;
      } else {
        this.duration = null;
      }
    } else {
      console.log("b");
      this.duration_unit = "0";
      if (this.idea.duration_from !== null && this.idea.duration_to !== null) {
        this.duration = [this.idea.duration_from, this.idea.duration_to];
      } else if (
        this.idea.duration_from !== null &&
        this.idea.duration_to === null
      ) {
        this.duration = this.idea.duration_from;
      } else {
        this.duration = null;
      }
    }

    //EDIT

    if (this.edit.duration_unit) {
      this.duration_unit_edit = "1";
      if (this.edit.duration_from !== null && this.edit.duration_to !== null) {
        console.log("daf", this.edit);
        console.log(this.edit.duration_from / 60);
        this.durationEdit = [
          this.edit.duration_from / 60,
          this.edit.duration_to / 60,
        ];
      } else if (
        this.edit.duration_from !== null &&
        this.edit.duration_to === null
      ) {
        this.durationEdit = parseFloat(
          parseInt(this.edit.duration_from) / 60.0
        );
      } else {
        this.durationEdit = null;
      }
    } else {
      this.duration_unit_edit = "0";
      if (this.edit.duration_from !== null && this.edit.duration_to !== null) {
        this.durationEdit = [this.edit.duration_from, this.edit.duration_to];
      } else if (
        this.edit.duration_from !== null &&
        this.edit.duration_to === null
      ) {
        this.durationEdit = this.edit.duration_from;
      } else {
        this.durationEdit = null;
      }
    }

    //PREPARE PRICE DATA
    if (this.idea.price_from !== null && this.idea.price_to !== null) {
      this.price = [this.idea.price_from, this.idea.price_to];
    } else if (this.idea.price_from !== null && this.idea.price_to === null) {
      this.price = this.idea.price_from;
    } else {
      this.price = null;
    }

    //PREPARE AMOUNT DATA
    if (this.idea.amount_from !== null && this.idea.amount_to !== null) {
      this.amount = [this.idea.amount_from, this.idea.amount_to];
    } else if (this.idea.amount_from !== null && this.idea.amount_to === null) {
      this.amount = this.idea.amount_from;
    } else {
      this.amount = null;
    }

    //EDIT

    if (this.edit.price_from !== null && this.edit.price_to !== null) {
      this.priceEdit = [this.edit.price_from, this.edit.price_to];
    } else if (this.edit.price_from !== null && this.edit.price_to === null) {
      this.priceEdit = this.edit.price_from;
    } else {
      this.priceEdit = null;
    }

    if (this.edit.amount_from !== null && this.edit.amount_to !== null) {
      this.amountEdit = [this.edit.amount_from, this.edit.amount_to];
    } else if (this.edit.amount_from !== null && this.edit.amount_to === null) {
      this.amountEdit = this.edit.amount_from;
    } else {
      this.amountEdit = null;
    }

    //PREPARE PREPERATION DATA

    if (this.idea.preperation) {
      this.preperation = "1";
    } else {
      this.preperation = "0";
    }
    //EDIT
    if (this.edit.preperation) {
      this.preperationEdit = "1";
    } else {
      this.preperationEdit = "0";
    }

    //PREPARE CATEGORY DATA

    if (this.idea.category !== null) {
      this.chosenCategories.main = this.idea.category;
    }
    if (this.idea.subcategory !== null) {
      this.chosenCategories.sub = this.idea.subcategory;
    }
    if (this.idea.subsubcategory !== null) {
      this.chosenCategories.subsub = this.idea.subsubcategory;
    }

    //EDIT
    if (this.edit.category !== null) {
      this.chosenCategoriesEdit.main = this.edit.category;
    }
    if (this.edit.subcategory !== null) {
      this.chosenCategoriesEdit.sub = this.edit.subcategory;
    }
    if (this.edit.subsubcategory !== null) {
      this.chosenCategoriesEdit.subsub = this.edit.subsubcategory;
    }
  },
  mounted() {
    //PREPARE ADDRESS DATA
    document.getElementById("gp-w").children[0].classList.add("ap-input");
    document.getElementById("gp-w-e").children[0].classList.add("ap-input");
    if (this.idea.address === null) {
      this.noAddress = true;

      document.querySelector(".ap-input").classList.add("input-disabled");
      document.querySelector(".ap-input").disabled = true;
    } else {
      this.geolocation = {
        latlng: {
          lat: this.idea.latitude,
          lng: this.idea.longitude,
        },
        city: this.idea.city,
        name: this.idea.address,
        zip: this.idea.zip,
        street: this.idea.street,
      };
      this.neutral = false;
      this.noAddress = false;
      this.address = this.idea.address;
      document.getElementById("gp-w").children[0].value = this.idea.address;
    }

    if (this.edit.address === null) {
      this.noAddressEdit = true;
      // document.querySelector(".ap-input").classList.add("input-disabled");
      // document.querySelector(".ap-input").disabled = true;
    } else {
      this.geolocationEdit = {
        latlng: {
          lat: this.edit.latitude,
          lng: this.edit.longitude,
        },
        city: this.edit.city,
        name: this.edit.address,
        zip: this.edit.zip,
        street: this.edit.street,
      };
      this.neutralEdit = false;
      this.noAddressEdit = false;
      this.addressEdit = this.edit.address;
      document.getElementById("gp-w-e").children[0].value = this.edit.address;

      // document.querySelector(".ap-input").value = this.edit.address;
    }

    this.categoriesEqual = _.isEqual(
      this.chosenCategories,
      this.chosenCategoriesEdit
    );
    this.titleEqual = _.isEqual(this.title, this.titleEdit);

    console.log("duration", this.duration);
    console.log("durationEdit", this.durationEdit);
    this.durationEqual = _.isEqual(this.duration, this.durationEdit);
    this.preperationEqual = _.isEqual(this.preperation, this.preperationEdit);
    this.ageEqual = _.isEqual(this.age, this.ageEdit);
    this.amountEqual = _.isEqual(this.amount, this.amountEdit);
    this.priceEqual = _.isEqual(this.price, this.priceEdit);
    this.locationEqual = _.isEqual(this.location, this.locationEdit);
    this.buyEqual = _.isEqual(this.buy_url, this.buy_urlEdit);
    this.websiteEqual = _.isEqual(this.website_url, this.website_urlEdit);
    this.descriptionEqual = _.isEqual(this.description, this.descriptionEdit);
    this.infrastructureEqual = _.isEqual(
      this.infrastructure,
      this.infrastructureEdit
    );
    console.log("time", this.time);
    console.log("time_EDIT", this.timeEdit);
    this.geotimeEqual = _.isEqual(
      { geo: this.geolocation, time: this.time },
      { geo: this.geolocationEdit, time: this.timeEdit }
    );
  },
  computed: {
    // categoriesEqual() {
    //   return _.isEqual(this.chosenCategories, this.chosenCategoriesEdit);
    // },
    // durationEqual() {
    //   return _.isEqual(this.duration, this.durationEdit);
    // },
    // preperationEqual() {
    //   return _.isEqual(this.preperation, this.preperationEdit);
    // },
    // ageEqual() {
    //   return _.isEqual(this.age, this.ageEdit);
    // },
    // amountEqual() {
    //   return _.isEqual(this.amount, this.amountEdit);
    // },
    // priceEqual() {
    //   return _.isEqual(this.price, this.priceEdit);
    // },
    // locationEqual() {
    //   return _.isEqual(this.location, this.locationEdit);
    // },
    // buyEqual() {
    //   return _.isEqual(this.buy_url, this.buy_urlEdit);
    // },
    // websiteEqual() {
    //   return _.isEqual(this.website_url, this.website_urlEdit);
    // },
    // descriptionEqual() {
    //   return _.isEqual(this.description, this.descriptionEdit);
    // },
    // infrastructureEqual() {
    //   return _.isEqual(this.infrastructure, this.infrastructureEdit);
    // },
  },
};
</script>

<style>
</style>
